import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import api from "../../../components/services/api";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import Swal from "sweetalert2";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import mime from "mime";
import { saveAs } from "file-saver";

export default function EditTrainSchedule() {
  const { id } = useParams();
  const history = useHistory();
  const [locationData, setLocationData] = useState([]);
  const [InboundRemark, setInboundRemark] = useState("");
  const [OutboundRemark, setOutboundRemark] = useState("");
  const [InboundETDDate, setInboundETDDate] = useState(null);
  const [InboundETDTime, setInboundETDTime] = useState(null);
  const [InboundETADate, setInboundETADate] = useState(null);
  const [InboundETATime, setInboundETATime] = useState(null);
  const [OutboundETDDate, setOutboundETDDate] = useState(null);
  const [OutboundETDTime, setOutboundETDTime] = useState(null);
  const [OutboundETADate, setOutboundETADate] = useState(null);
  const [OutboundETATime, setOutboundETATime] = useState(null);
  const [InboundDepartWagonQty, setInboundDepartWagonQty] = useState("0");
  const [InboundArriveWagonQty, setInboundArriveWagonQty] = useState("0");
  const [OutboundDepartWagonQty, setOutboundDepartWagonQty] = useState("0");
  const [OutboundArriveWagonQty, setOutboundArriveWagonQty] = useState("0");
  const [InboundStatus, setInboundStatus] = useState(false);
  const [OutboundStatus, setOutboundStatus] = useState(false);
  const [wagon, setWagon] = useState([]);
  const [wagonNew, setWagonNew] = useState([]);
  const [voyNo, setVoyNo] = useState("");
  const [open, setOpen] = React.useState(false);
  const [Loading, setLoading] = React.useState(false);
  const [LoadingVoy, setLoadingVoy] = React.useState("");
  const [page, setPage] = useState({});

  const [DetailTrainList, setDetailTrainList] = useState([]);

  const TrainScheduleDetails = async () => {
    try {
      await api.get(`api/train/detail/station/${id}`).then((res) => {
        setPage(res.data.page);
        setDetailTrainList(res.data);
        setInboundETDDate(res.data.InboundETDDate);
        setInboundETDTime(res.data.InboundETDTime);
        setInboundETADate(res.data.InboundETADate);
        setInboundETATime(res.data.InboundETATime);
        setInboundRemark(res.data.InboundRemark);
        setInboundDepartWagonQty(res.data.InboundDepartWagonQty);
        setInboundArriveWagonQty(res.data.InboundArriveWagonQty);
        setOutboundETDDate(res.data.OutboundETDDate);
        setOutboundETDTime(res.data.OutboundETDTime);
        setOutboundETADate(res.data.OutboundETADate);
        setOutboundETATime(res.data.OutboundETATime);
        setOutboundRemark(res.data.OutboundRemark);
        setOutboundDepartWagonQty(res.data.OutboundDepartWagonQty);
        setOutboundArriveWagonQty(res.data.OutboundArriveWagonQty);
        setInboundStatus(res.data.InboundStatus);
        setOutboundStatus(res.data.OutboundStatus);
        const inB = res.data.InboundStation?.map((x, i) => {
          x.id = i + 1;

          return x;
        });

        setRows([...inB]);
        const outB = res.data.OutboundStation?.map((x, i) => {
          x.id = i + 1;

          return x;
        });

        setRowsOut([...outB]);
      });
    } catch (error) {
      console.log("error => ", error);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getWagon = async () => {
    try {
      const res = await api.get(`api/train/detail/wagon/${voyNo}`);
      const data = await res.data;
      if (res.meta.status === true) {
        setWagonNew(data);
        setWagon(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const updateWagon = async () => {
    const body = {
      Details: wagonNew,
    };
    try {
      const res = await api.post(`api/train/update/wagon/${voyNo}`, body);
      const data = await res.meta;
      if (data.status) {
        setOpen(false);

        Swal.fire({
          title: `${data.message}`,
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            setVoyNo("");
            setWagon([]);
            setWagonNew([]);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (voyNo) {
      getWagon();
    }
  }, [voyNo]);
  useEffect(() => {
    TrainScheduleDetails();
    getLocation();
  }, []);

  const [rows, setRows] = useState([]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      VoyageScheduleId: null,
      LocationId: null,
      ETADate: null,
      ETATime: "",
      ETDDate: null,
      ETDTime: "",
      WagonQty: 0,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e) => i !== e?.id);
    setRows(data);
  };
  const [rowsOut, setRowsOut] = useState([]);
  function addRowOut() {
    const newRow = {
      id: rowsOut?.slice(-1)[0]?.id ? rowsOut?.slice(-1)[0]?.id + 1 : 1,
      VoyageScheduleId: null,
      LocationId: null,
      ETADate: null,
      ETATime: "",
      ETDDate: null,
      ETDTime: "",
      WagonQty: 0,
    };

    setRowsOut([...rowsOut, newRow]);
  }
  const deletehandOut = (i) => {
    const data = rowsOut?.filter((e) => i !== e?.id);
    setRowsOut(data);
  };

  const PostData = async (e) => {
    e.preventDefault();
    const body = {
      VoyageScheduleTrainId: id,
      InboundETDDate: InboundETDDate,
      InboundETDTime: InboundETDTime,
      InboundDepartWagonQty: InboundDepartWagonQty,
      InboundStation: rows,
      InboundETADate: InboundETADate,
      InboundETATime: InboundETATime,
      InboundArriveWagonQty: InboundArriveWagonQty,
      InboundRemark: InboundRemark,
      OutboundETDDate: OutboundETDDate,
      OutboundETDTime: OutboundETDTime,
      OutboundDepartWagonQty: OutboundDepartWagonQty,
      OutboundStation: rowsOut,
      OutboundETADate: OutboundETADate,
      OutboundETATime: OutboundETATime,
      OutboundArriveWagonQty: OutboundArriveWagonQty,
      OutboundRemark: OutboundRemark,
      InboundStatus: InboundStatus,
      OutboundStatus: OutboundStatus,
    };
    const res = await api.post(`api/train/update`, body);
    if (res.meta.status === true) {
      Swal.fire("อัพเดทสำเร็จ", "ส่งข้อมูลสำเร็จ", "success");
      TrainScheduleDetails();
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setVoyNo("");
    setWagon([]);
    setWagonNew([]);
  };
  const getWagonList = async (voy) => {
    setLoading(true);
    setLoadingVoy(voy);
    await api
      .get(`api/report/wagon-list/download/excel?voyNo=${voy}`, {
        responseType: "blob",
        timeout: 30000,
      })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "ใบแจ้งรถไฟ.xlsx");
        setLoading(false);
        setLoadingVoy("");
      });
  };
  // const getPDF = async (voy) => {
  //   setLoading(true);
  //   setLoadingVoy(voy);
  //   await api
  //     .get(`api/report/wagon-list/download/pdf?voyNo=${voy}`, {
  //       responseType: "blob",
  //       timeout: 30000,
  //     })
  //     .then((blobFile) => {
  //       const blobFileRes = new File([blobFile?.data], "test.pdf", {
  //         type: mime.getType(".pdf"),
  //       });

  //       // window.open(
  //       //   URL.createObjectURL(blobFileRes, "test.csv"),
  //       //   "_blank"
  //       // );
  //       saveAs(blobFileRes, "Report-Container-List-Loading.pdf");
  //       setLoading(false);
  //       setLoadingVoy("");
  //     });
  // };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ตารางการรถไฟ
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Train Schedule
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Train</Typography>
              <Typography>
                <span>&nbsp;</span> / Train Schedule
              </Typography>
            </Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid xs={5} sx={{ marginRight: "15px" }}>
              <TextField
                value={DetailTrainList?.RouteName || ""}
                fullWidth
                label="Train"
                variant="outlined"
              />
            </Grid>
            <Grid xs={5} sx={{ marginRight: "15px" }}>
              <TextField
                value={DetailTrainList?.RouteType || ""}
                fullWidth
                label="Type"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <form onSubmit={(e) => PostData(e)}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "85%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  marginTop: "10px",
                  paddingBottom: "24px",
                }}
              >
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                  }}
                  // disabled={isEdit !== false ? true : false}
                >
                  save
                </Button>
              </Box>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  marginTop: "10px",
                  paddingBottom: "24px",
                }}
              >
                {page?.previousPage && (
                  <a href={`/Planner/EditTrainSchedule/${page?.previousPage}`}>
                    <Button
                      style={{
                        backgroundColor: "#007bff",
                        color: "#fafafa",
                        display: "flex",
                        justifyContent: "center",
                        marginRight: "10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`< Previous`}
                    </Button>
                  </a>
                )}
                {page?.nextPage && (
                  <a href={`/Planner/EditTrainSchedule/${page?.nextPage}`}>
                    <Button
                      style={{
                        backgroundColor: "#007bff",
                        color: "#fafafa",
                        display: "flex",
                        justifyContent: "center",
                        marginRight: "10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`Next >`}
                    </Button>
                  </a>
                )}
              </div>
            </div>

            <Grid container>
              <Grid
                xs={5}
                sx={{ background: "#30318D", padding: "10px", color: "#fff" }}
              >
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  {DetailTrainList?.LocationFrom} -{" "}
                  {DetailTrainList?.LocationTo}
                </Typography>
              </Grid>

              <Grid
                xs={5}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  background: "#30318D",
                  padding: "10px",
                  color: "#fff",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "15px",
                  }}
                >
                  <Typography>Omit</Typography>
                  <Switch
                    checked={InboundStatus}
                    onChange={(e) => setInboundStatus(e.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                    color="default"
                  />
                  <Typography>Open</Typography>
                </Box>

                <Typography
                  sx={{
                    textAlign: "end",
                    marginRight: "20px",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  {" "}
                  {DetailTrainList?.InboundVoyNo}
                </Typography>
                <Button
                  variant="outlined"
                  sx={{
                    background: "#fff",
                    color: "#30318D",
                    ":hover": {
                      background: "#e9e9e9",
                    },
                  }}
                  onClick={() => {
                    handleClickOpen();
                    setVoyNo(DetailTrainList?.InboundVoyNo);
                  }}
                >
                  {" "}
                  Wagon Detail
                </Button>
              </Grid>
              <Grid xs={10}>
                <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ width: "30%" }}>
                          Station
                        </TableCell>
                        <TableCell align="center" sx={{ width: "20%" }}>
                          ETA Date
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          ETA Time
                        </TableCell>
                        <TableCell align="center" sx={{ width: "20%" }}>
                          ETD Date
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          ETD Time
                        </TableCell>
                        <TableCell align="center" sx={{ width: "15%" }}>
                          Wagon QTY
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <TextField
                            value={DetailTrainList?.LocationFrom || ""}
                            fullWidth
                            label="Station"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell> </TableCell>
                        <TableCell></TableCell>
                        <TableCell>
                          <DesktopDatePicker
                            label="date"
                            value={InboundETDDate || null}
                            inputFormat="dd/MM/yyyy"
                            // minDate={dateStart ? dateStart : new Date()}
                            onChange={(newValue) => {
                              setInboundETDDate(
                                moment(newValue).format("yyyy-MM-DD")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                fullWidth
                                required
                                {...params}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            required
                            value={InboundETDTime || ""}
                            onChange={(e) => setInboundETDTime(e.target.value)}
                            fullWidth
                            label="time"
                            type="time"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={InboundDepartWagonQty || ""}
                            onChange={(e) =>
                              setInboundDepartWagonQty(e.target.value)
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            fullWidth
                            label="WagonQty"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <Button variant="outlined" onClick={() => addRow()}>
                            add
                          </Button>
                        </TableCell>
                      </TableRow>
                      {rows.map((x, i) => (
                        <TableRow>
                          <TableCell>
                            <FormControl required fullWidth size="small">
                              <InputLabel id="locationFrom">
                                Location
                              </InputLabel>
                              <Select
                                value={x?.LocationId || ""}
                                label="Location"
                                onChange={(e) => {
                                  const io = rows?.map((v) => {
                                    v.LocationId =
                                      v?.id === x?.id
                                        ? e.target.value
                                        : v?.LocationId;
                                    return v;
                                  });

                                  setRows([...io]);
                                }}
                              >
                                {locationData.map((x) => (
                                  <MenuItem value={x.LocationId}>
                                    {x.LocationName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <DesktopDatePicker
                              label="date"
                              value={x.ETADate || null}
                              inputFormat="dd/MM/yyyy"
                              // minDate={dateStart ? dateStart : new Date()}
                              onChange={(newValue) => {
                                const io = rows?.map((v) => {
                                  v.ETADate =
                                    v?.id === x?.id
                                      ? moment(newValue).format("yyyy-MM-DD")
                                      : v?.ETADate;
                                  return v;
                                });

                                setRows([...io]);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  required
                                  {...params}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.ETATime || ""}
                              fullWidth
                              label="time"
                              type="time"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.ETATime =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.ETATime;
                                  return v;
                                });

                                setRows([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <DesktopDatePicker
                              label="date"
                              value={x.ETDDate || null}
                              inputFormat="dd/MM/yyyy"
                              minDate={new Date(x.ETADate)}
                              onChange={(newValue) => {
                                const io = rows?.map((v) => {
                                  v.ETDDate =
                                    v?.id === x?.id
                                      ? moment(newValue).format("yyyy-MM-DD")
                                      : v?.ETDDate;
                                  return v;
                                });

                                setRows([...io]);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  required
                                  {...params}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.ETDTime || ""}
                              fullWidth
                              label="time"
                              type="time"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.ETDTime =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.ETDTime;
                                  return v;
                                });

                                setRows([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.WagonQty || ""}
                              fullWidth
                              label="WagonQty"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.WagonQty =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.WagonQty;
                                  return v;
                                });

                                setRows([...io]);
                              }}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </TableCell>

                          <TableCell>
                            {" "}
                            <Button
                              variant="outlined"
                              onClick={() => deletehand(x.id)}
                            >
                              delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell>
                          <TextField
                            value={DetailTrainList?.LocationTo || ""}
                            fullWidth
                            label="Station"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          {" "}
                          <DesktopDatePicker
                            label="date"
                            value={InboundETADate || null}
                            inputFormat="dd/MM/yyyy"
                            // minDate={dateStart ? dateStart : new Date()}
                            onChange={(newValue) => {
                              setInboundETADate(
                                moment(newValue).format("yyyy-MM-DD")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                fullWidth
                                required
                                {...params}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            required
                            value={InboundETATime || ""}
                            onChange={(e) => setInboundETATime(e.target.value)}
                            fullWidth
                            label="time"
                            type="time"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>

                        <TableCell>
                          <TextField
                            value={InboundArriveWagonQty || ""}
                            onChange={(e) =>
                              setInboundArriveWagonQty(e.target.value)
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            fullWidth
                            label="WagonQty"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TextField
                  value={InboundRemark || ""}
                  onChange={(e) => setInboundRemark(e.target.value)}
                  fullWidth
                  label="Remark"
                  size="small"
                  variant="outlined"
                />
                <Button
                  variant="outlined"
                  sx={{
                    marginTop: "14px",
                    width: "250px",
                    background: "#30318D",
                    color: "#fff",
                    ":hover": {
                      background: "#30318D",
                    },
                  }}
                  onClick={() => {
                    getWagonList(DetailTrainList?.InboundVoyNo);
                    setVoyNo(DetailTrainList?.InboundVoyNo);
                  }}
                >
                  {Loading && LoadingVoy === DetailTrainList?.InboundVoyNo ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Print ใบแจ้งรถไฟตู้เปล่า"
                  )}
                </Button>
                {/* <Button
                  variant="outlined"
                  sx={{
                    marginTop: "14px",
                    width: "250px",
                    background: "#30318D",
                    color: "#fff",
                    ":hover": {
                      background: "#30318D",
                    },
                  }}
                  onClick={() => {
                    getPDF(DetailTrainList?.InboundVoyNo);
                    setVoyNo(DetailTrainList?.InboundVoyNo);
                  }}
                >
                  {Loading && LoadingVoy === DetailTrainList?.InboundVoyNo ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Print Container List"
                  )}
                </Button> */}
              </Grid>
            </Grid>
            <Divider sx={{ marginTop: "50px" }} />
            <Grid container sx={{ marginTop: "50px" }}>
              <Grid
                xs={5}
                sx={{ background: "#80c340", padding: "10px", color: "#fff" }}
              >
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  {DetailTrainList?.LocationTo} -{" "}
                  {DetailTrainList?.LocationFrom}
                </Typography>
              </Grid>
              <Grid
                xs={5}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  background: "#80c340",
                  padding: "10px",
                  color: "#fff",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "15px",
                  }}
                >
                  <Typography>Omit</Typography>
                  <Switch
                    checked={OutboundStatus}
                    onChange={(e) => setOutboundStatus(e.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                    color="default"
                  />
                  <Typography>Open</Typography>
                </Box>
                <Typography
                  sx={{
                    textAlign: "end",
                    marginRight: "20px",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  {" "}
                  {DetailTrainList?.OutboundVoyNo}
                </Typography>
                <Button
                  variant="outlined"
                  sx={{
                    background: "#fff",
                    color: "#000",
                    ":hover": {
                      background: "#e9e9e9",
                    },
                  }}
                  onClick={() => {
                    handleClickOpen();
                    setVoyNo(DetailTrainList?.OutboundVoyNo);
                  }}
                >
                  {" "}
                  Wagon Detail
                </Button>
              </Grid>
              <Grid xs={10}>
                <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ width: "30%" }}>
                          Station
                        </TableCell>
                        <TableCell align="center" sx={{ width: "20%" }}>
                          ETA Date
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          ETA Time
                        </TableCell>
                        <TableCell align="center" sx={{ width: "20%" }}>
                          ETD Date
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          ETD Time
                        </TableCell>
                        <TableCell align="center" sx={{ width: "15%" }}>
                          Wagon QTY
                        </TableCell>
                        <TableCell align="center" sx={{ width: "5%" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <TextField
                            value={DetailTrainList?.LocationTo || ""}
                            fullWidth
                            label="Station"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell> </TableCell>
                        <TableCell></TableCell>
                        <TableCell>
                          <DesktopDatePicker
                            label="date"
                            value={OutboundETDDate || null}
                            inputFormat="dd/MM/yyyy"
                            // minDate={dateStart ? dateStart : new Date()}
                            onChange={(newValue) => {
                              setOutboundETDDate(
                                moment(newValue).format("yyyy-MM-DD")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                size="small"
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            required
                            value={OutboundETDTime || ""}
                            onChange={(e) => setOutboundETDTime(e.target.value)}
                            fullWidth
                            label="time"
                            type="time"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={OutboundDepartWagonQty || ""}
                            onChange={(e) =>
                              setOutboundDepartWagonQty(e.target.value)
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            fullWidth
                            label="WagonQty"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            onClick={() => addRowOut()}
                          >
                            add
                          </Button>
                        </TableCell>
                      </TableRow>
                      {rowsOut.map((x, i) => (
                        <TableRow>
                          <TableCell>
                            <FormControl required fullWidth size="small">
                              <InputLabel id="locationFrom">
                                Location
                              </InputLabel>
                              <Select
                                value={x?.LocationId || ""}
                                label="Location"
                                onChange={(e) => {
                                  const io = rowsOut?.map((v) => {
                                    v.LocationId =
                                      v?.id === x?.id
                                        ? e.target.value
                                        : v?.LocationId;
                                    return v;
                                  });

                                  setRowsOut([...io]);
                                }}
                              >
                                {locationData.map((x) => (
                                  <MenuItem value={x.LocationId}>
                                    {x.LocationName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <DesktopDatePicker
                              label="date"
                              value={x.ETADate || null}
                              inputFormat="dd/MM/yyyy"
                              // minDate={dateStart ? dateStart : new Date()}
                              onChange={(newValue) => {
                                const io = rowsOut?.map((v) => {
                                  v.ETADate =
                                    v?.id === x?.id
                                      ? moment(newValue).format("yyyy-MM-DD")
                                      : v?.ETADate;
                                  return v;
                                });

                                setRowsOut([...io]);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  required
                                  {...params}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.ETATime || ""}
                              fullWidth
                              label="time"
                              type="time"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rowsOut?.map((v) => {
                                  v.ETATime =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.ETATime;
                                  return v;
                                });

                                setRowsOut([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <DesktopDatePicker
                              label="date"
                              value={x.ETDDate || null}
                              inputFormat="dd/MM/yyyy"
                              minDate={new Date(x.ETADate)}
                              onChange={(newValue) => {
                                const io = rowsOut?.map((v) => {
                                  v.ETDDate =
                                    v?.id === x?.id
                                      ? moment(newValue).format("yyyy-MM-DD")
                                      : v?.ETDDate;
                                  return v;
                                });

                                setRowsOut([...io]);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  required
                                  {...params}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.ETDTime || ""}
                              fullWidth
                              label="time"
                              type="time"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rowsOut?.map((v) => {
                                  v.ETDTime =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.ETDTime;
                                  return v;
                                });

                                setRowsOut([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              required
                              value={x?.WagonQty}
                              fullWidth
                              label="WagonQty"
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                const io = rowsOut?.map((v) => {
                                  v.WagonQty =
                                    v?.id === x?.id
                                      ? e.target.value
                                      : v?.WagonQty;
                                  return v;
                                });

                                setRowsOut([...io]);
                              }}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Button
                              variant="outlined"
                              onClick={() => deletehandOut(x.id)}
                            >
                              delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell>
                          <TextField
                            required
                            value={DetailTrainList?.LocationFrom || ""}
                            fullWidth
                            label="Station"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          {" "}
                          <DesktopDatePicker
                            label="date"
                            value={OutboundETADate || null}
                            inputFormat="dd/MM/yyyy"
                            // minDate={dateStart ? dateStart : new Date()}
                            onChange={(newValue) => {
                              setOutboundETADate(
                                moment(newValue).format("yyyy-MM-DD")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                size="small"
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            required
                            value={OutboundETATime || ""}
                            onChange={(e) => setOutboundETATime(e.target.value)}
                            fullWidth
                            label="time"
                            type="time"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>
                          <TextField
                            value={OutboundArriveWagonQty || ""}
                            onChange={(e) =>
                              setOutboundArriveWagonQty(e.target.value)
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            fullWidth
                            label="WagonQty"
                            size="small"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TextField
                  value={OutboundRemark || ""}
                  onChange={(e) => setOutboundRemark(e.target.value)}
                  fullWidth
                  label="Remark"
                  size="small"
                  variant="outlined"
                />
                <Button
                  variant="outlined"
                  sx={{
                    marginTop: "14px",
                    width: "250px",
                    background: "#80c340",
                    color: "#fff",
                    ":hover": {
                      background: "#80c340",
                    },
                  }}
                  onClick={() => {
                    getWagonList(DetailTrainList?.OutboundVoyNo);
                    setVoyNo(DetailTrainList?.OutboundVoyNo);
                  }}
                >
                  {Loading && LoadingVoy === DetailTrainList?.OutboundVoyNo ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Print ใบแจ้งรถไฟตู้หนัก"
                  )}
                </Button>
                {/* <Button
                  variant="outlined"
                  sx={{
                    marginTop: "14px",
                    width: "250px",
                    background: "#80c340",
                    color: "#fff",
                    ":hover": {
                      background: "#80c340",
                    },
                  }}
                  onClick={() => {
                    getPDF(DetailTrainList?.OutboundVoyNo);
                    setVoyNo(DetailTrainList?.OutboundVoyNo);
                  }}
                >
                  {Loading && LoadingVoy === DetailTrainList?.OutboundVoyNo ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Print Container List"
                  )}
                </Button> */}
              </Grid>
            </Grid>
          </form>
        </Card>
      </LocalizationProvider>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogContent
          sx={{
            minHeight: 500,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TableContainer sx={{ marginBottom: "20px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead
                sx={{
                  position: "sticky",
                  top: "0",
                  background: "#fff !important",
                  zIndex: 99,
                }}
              >
                <TableRow>
                  <TableCell sx={{ width: "70px" }}>
                    <Checkbox
                      size="small"
                      // sx={{
                      //   color: '#fff',

                      //   "&.Mui-checked": {
                      //     color: '#fff',
                      //   },
                      // }}
                      onChange={(e) => {
                        const select = wagon?.map((y) => {
                          y.isCheck =
                            e.target.checked === true && y?.Status !== 0
                              ? true
                              : false;
                          return y;
                        });

                        setWagonNew([...select]);
                      }}
                      // checked={wagon?.selected || false}
                    />
                  </TableCell>
                  <TableCell sx={{ width: "150px" }}>No.</TableCell>
                  <TableCell>Wagon No.</TableCell>
                  <TableCell>Cntr No. 1</TableCell>
                  <TableCell sx={{ width: "50px" }}></TableCell>
                  <TableCell>Cntr No. 2</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {wagonNew?.map((row, i) => (
                  <TableRow
                    key={i}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <Checkbox
                        size="small"
                        // sx={{
                        //   color: green[500],
                        //   "&.Mui-checked": {
                        //     color: green[500],
                        //   },
                        // }}
                        onChange={(e) => {
                          const select = wagon?.map((y, index) => {
                            y.isCheck =
                              index === i
                                ? e.target.checked === true
                                  ? true
                                  : false
                                : y?.isCheck;
                            return y;
                          });

                          setWagonNew([...select]);
                        }}
                        checked={row?.isCheck ? true : false}
                        disabled={row?.Status === 0 ? true : false}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        disabled={!row?.isCheck}
                        label="No."
                        size="small"
                        variant="outlined"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        fullWidth
                        value={row?.No}
                        onChange={(e) => {
                          const select = wagon?.map((y, index) => {
                            y.No = index === i ? e.target.value : y?.No;

                            return y;
                          });
                          setWagonNew([...select]);
                        }}
                      />
                    </TableCell>
                    <TableCell>{row?.WagonNo}</TableCell>
                    <TableCell>{row?.ContainerNo_1}</TableCell>
                    <TableCell>
                      <Button
                        disabled={!row?.isCheck}
                        onClick={() => {
                          let c1 = row?.ContainerNo_1;
                          let c2 = row?.ContainerNo_2;
                          const select = wagon?.map((y, index) => {
                            y.ContainerNo_2 =
                              index === i ? c1 : y?.ContainerNo_2;
                            y.ContainerNo_1 =
                              index === i ? c2 : y?.ContainerNo_1;

                            return y;
                          });
                          setWagonNew([...select]);
                        }}
                        variant="contained"
                      >
                        <CompareArrowsIcon />
                      </Button>
                    </TableCell>
                    <TableCell>{row?.ContainerNo_2}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {wagon?.length === 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                position: "absolute",
                top: "50%",
              }}
            >
              <Typography>ไม่มีข้อมูล</Typography>
            </Box>
          )}
          <Box sx={{ display: "flex" }}>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ marginRight: "30px" }}
            >
              close
            </Button>
            <Button
              onClick={() => {
                updateWagon(DetailTrainList?.OutboundVoyNo);
              }}
              variant="contained"
            >
              update
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
